import { Fragment } from "react";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";

export const LeaseInformation = ({ detailsFormValues, isOld }) => {
  const { authorizationReport, authorizations } = useSelector(
    (state) => state.authorizationReport
  );
  const {
    subtotalExpenseAutorized,
    subtotalExpenseNotAutorized,
    subtotalIncomesAutorized,
    totalExpensePersonalAutorized,
    taxISRLease,
    taxIVALease,
  } = detailsFormValues;

  const { blindDeduction, isBlindDeduction } = taxISRLease;

  const considered =
    authorizations.paymentComplementExpensesSubtotal ||
    authorizationReport.paymentComplementExpensesSubtotal ||
    0;
  const consideredExpenseTotalAcreditable =
    parseFloat(subtotalExpenseAutorized) + parseFloat(considered);

  if (isOld) {
    return (
      <div className="col-md-6">
        <strong>Ingresos:</strong>
        <NumberFormat
          value={parseFloat(subtotalIncomesAutorized).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        <strong>Deducciones Personales:</strong>
        <NumberFormat
          value={parseFloat(totalExpensePersonalAutorized).toFixed(2)}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
        />
        <br />
        {isBlindDeduction ? (
          <Fragment>
            <strong>Deducción ciega:</strong>
            <NumberFormat
              value={parseFloat(blindDeduction).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        ) : (
          <Fragment>
            <strong>Deducciones Autorizadas:</strong>
            <NumberFormat
              value={parseFloat(consideredExpenseTotalAcreditable).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
            <strong>No deducibles:</strong>
            <NumberFormat
              value={parseFloat(subtotalExpenseNotAutorized).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        )}
        {parseFloat(taxIVALease.totalIVA) >= 0 ? (
          <Fragment>
            <strong>Total a pagar de IVA:</strong>
            <NumberFormat
              value={parseFloat(taxIVALease.totalIVA).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        ) : (
          <Fragment>
            <strong>Total a favor de IVA:</strong>
            <NumberFormat
              value={parseFloat(parseFloat(taxIVALease.totalIVA) * -1).toFixed(
                6
              )}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        )}
        <strong>Total a pagar de ISR:</strong>
        {parseFloat(taxISRLease.totalISR) >= 0 ? (
          <Fragment>
            <NumberFormat
              value={parseFloat(taxISRLease.totalISR).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        ) : (
          <Fragment>
            <NumberFormat
              value={parseFloat(0.0).toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
            <br />
          </Fragment>
        )}
            
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table
        className="table table-bordered table-sm mb-0"
        style={{ tableLayout: "auto", whiteSpace: "nowrap" }}
      >
        <thead className="thead-light">
          <tr>
            <th className="align-middle text-center" colSpan={2}>
              Valores Arrendamiento
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="font-weight-bold">Ingresos</td>
            <td>
              <NumberFormat
                value={parseFloat(subtotalIncomesAutorized).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Deducciones Personales</td>
            <td>
              <NumberFormat
                value={parseFloat(totalExpensePersonalAutorized).toFixed(2)}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
          {isBlindDeduction ? (
            <tr>
              <td className="font-weight-bold">Deducción ciega</td>
              <td>
                <NumberFormat
                  value={parseFloat(blindDeduction).toFixed(2)}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                />
              </td>
            </tr>
          ) : (
            <>
              <tr>
                <td className="font-weight-bold">Deducciones Autorizadas</td>
                <td>
                  <NumberFormat
                    value={parseFloat(
                      consideredExpenseTotalAcreditable
                    ).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </td>
              </tr>
              <tr>
                <td className="font-weight-bold">No deducibles</td>
                <td>
                  <NumberFormat
                    value={parseFloat(subtotalExpenseNotAutorized).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </td>
              </tr>
            </>
          )}
          <tr>
            {parseFloat(taxIVALease.totalIva) >= 0 ? (
              <td>
                <span className="font-weight-bold">Total a pagar de IVA</span>
              </td>
            ) : (
              <td>
                <span className="font-weight-bold">Total a favor de IVA</span>
              </td>
            )}
            <td>
              {parseFloat(taxIVALease.totalIVA) >= 0 ? (
                <span>
                  <NumberFormat
                    value={parseFloat(taxIVALease.totalIVA).toFixed(2)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </span>
              ) : (
                <span>
                  <NumberFormat
                    value={(parseFloat(taxIVALease.totalIVA) * -1).toFixed(6)}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                  />
                </span>
              )}
            </td>
          </tr>
          <tr>
            <td className="font-weight-bold">Total a pagar de ISR</td>
            <td>
              <NumberFormat
                value={
                  parseFloat(taxISRLease.totalISR) >= 0
                    ? parseFloat(taxISRLease.totalISR).toFixed(2)
                    : parseFloat(0.0).toFixed(2)
                }
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
